export const shadow = {
  boxShadow: {
    scale: 'boxShadows',
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Shadow = typeof shadow;
